import { FadeUp, Overline, MaskedLines } from "@/components/Reveal";
import { STRENGTHS } from "@/data/site";

export default function Manifesto() {
  return (
    <section id="about" data-testid="manifesto-section" className="py-28 md:py-40 bg-charcoal/40 border-y hairline">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <FadeUp>
              <Overline>The Studio</Overline>
            </FadeUp>
            <h2 className="mt-8 font-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              <MaskedLines lines={["BEHIND EVERY GREAT IMAGE", "IS GREAT CRAFT."]} />
            </h2>
            <FadeUp delay={0.25} className="mt-10 max-w-xl space-y-6 text-sm md:text-base text-ivory/70 font-light leading-relaxed">
              <p>
                Vcontractz Solutions India Pvt. Ltd. works behind the scenes with
                photographers and property professionals around the world, transforming
                raw captures into polished visual assets ready for listings, campaigns,
                websites and social media.
              </p>
            </FadeUp>
            <FadeUp delay={0.35} className="mt-10 border-l-2 border-gold/50 pl-8">
              <p className="font-display italic text-xl md:text-2xl text-ivory leading-relaxed">
                Enhance the image.<br />
                Preserve the vision.<br />
                <span className="text-gold">Never make it look artificial.</span>
              </p>
            </FadeUp>
          </div>

          <div className="lg:col-span-5 lg:pt-24">
            <div className="grid grid-cols-1 border-t hairline">
              {STRENGTHS.map((s, i) => (
                <FadeUp key={s} delay={0.05 * i}>
                  <div className="flex items-center justify-between border-b hairline py-5 group">
                    <span className="text-[11px] md:text-xs uppercase tracking-[0.3em] text-ivory/80 group-hover:text-gold transition-colors duration-300">
                      {s}
                    </span>
                    <span className="font-display text-bronze/70 text-sm">0{i + 1}</span>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
